const sortings = ['default', 'radius']
const stylings = ['ping', 'pld']
const languages = ['en', 'fr']

export default class ImportValidator {
    /**
     * Method validates a string as a boolean
     * @returns a boolean value
     */
    static validateBool = (value, backup) => {
        if (value !== null && value?.toLowerCase() === 'true') {
            return true
        }
        if (value !== null && value?.toLowerCase() === 'false') {
            return false
        }

        return backup ?? false
    }

    /**
     * Method validates a string as an integer
     * @returns an integer value or the default
     */
    static validateInt = (value, backup) => {
        return value !== null && !isNaN(parseInt(value)) ? parseInt(value) : backup
    }

    /**
     * Method retrieves a string as an array
     * @returns an array of strings
     */
    static validateStringToArray = value => {
        return value !== null ? value.split(',') : []
    }

    /**
     * Method validates a string
     * @returns an string value or the default
     */
    static validateString = (value, backup) => {
        return value !== null && value !== undefined ? value : backup
    }

    /**
     * Method validates a string as an number
     * @returns an number value or the default
     */
    static validateNumber = (value, backup) => {
        return value !== null && !isNaN(parseFloat(value)) ? parseFloat(value) : backup
    }

    /**
     * Method retrieves the validated sorting methods
     * @returns a string of the correct sorting method
     */
    static validateSort = value => {
        if (value !== null && value === 'hide') {
            return value
        }

        return value !== null && sortings.indexOf(value?.toLowerCase()) > -1 ? sortings[sortings.indexOf(value?.toLowerCase())] : sortings[0]
    }

    /**
     * Method retrieves the validated language methods
     * @returns a string of the correct language method
     */
    static validateLanguage = value => {
        if (value !== null && value === 'hide') {
            return value
        }

        return value !== null && languages.indexOf(value?.toLowerCase()) > -1 ? languages[languages.indexOf(value?.toLowerCase())] : languages[0]
    }

    /**
     * Method retrieves the validated style sheet to globally use
     * @returns a string of the correct style sheet
     */
    static validateStylings = value => {
        return value !== null && stylings.indexOf(value?.toLowerCase()) > -1 ? stylings[stylings.indexOf(value?.toLowerCase())] : stylings[0]
    }
}
